module.exports = __webpack_public_path__ + "static/media/ptbi@2x.4fb3c66e.png";